import { FunctionComponent } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import PubSub from 'pubsub-js';
import reduce from 'lodash/reduce';
import classNames from 'classnames';
import Currency from '../common/Currency';
import FreeDelivery from './FreeDelivery';
import Warnings from './Warnings';
import { BASKET_CHANGED } from '../topics';
import { ExternalBasket } from '../types';

const BasketSummary: FunctionComponent<BasketSummaryProps> = ({ defaultTotalItems, defaultSubTotalExcludingSurcharges, defaultAmountUntilFreeDelivery, defaultHasWarnings, checkoutDisabled }) => {
    const [ totalItems, setTotalItems ] = useState<number>(defaultTotalItems);
    const [ subTotal, setSubTotal ] = useState<string>(defaultSubTotalExcludingSurcharges);
    const [ amountUntilFreeDelivery, setAmountUntilFreeDelivery ] = useState<string>(defaultAmountUntilFreeDelivery);
    const [ hasWarnings, setHasWarnings ] = useState<boolean>(defaultHasWarnings);

    useEffect(() => {
        const token = PubSub.subscribe(BASKET_CHANGED, (topic, basket: ExternalBasket) => {
            const totalItems = reduce(basket.items, (sum, item, sku) => sum + item.quantity, 0);

            setTotalItems(totalItems);
            setSubTotal(basket.subtotal_excluding_surcharges);
            setAmountUntilFreeDelivery(basket.amount_until_free_delivery);
            setHasWarnings(basket.errors.length > 0 || basket.surcharges.length > 0);
        });

        return () => PubSub.unsubscribe(token);
    });

    if (totalItems === 0) {
        return <div class="d-sm-flex justify-content-center align-items-stretch py-3">
            <div class="header__basket-summary_cart -empty">
                Your Basket is currently empty
                <span id="js-header-basket-total" class="d-none">0</span>
            </div>
        </div>
    }

    return <div className="d-sm-flex justify-content-end align-items-stretch py-3">
        <div className="header__basket-summary_cart">
            <div className="d-sm-none d-md-inline-block">
                <span className="text-muted"> Items:</span>
                <span id="js-header-basket-total" className="text-xl font-weight-bold ml-2">{totalItems}</span>
            </div>
            <span className="text-muted ml-4">Total:</span>
            <span className="text-xl font-weight-bold ml-2">
                <Currency amount={subTotal}/>
            </span>
        </div>
        <FreeDelivery amountUntilFreeDelivery={amountUntilFreeDelivery}/>
        <Warnings warnings={hasWarnings}/>
        <a href="/basket"
           class={classNames('btn btn-primary py-2 font-weight-normal d-block d-sm-flex justify-content-center align-items-center text-center', { disabled: checkoutDisabled })}>
            Checkout
            <i class="buying-options__pagination-chevron d-inline-block ml-2" aria-hidden="true"></i>
        </a>
    </div>;
};

interface BasketSummaryProps {
    defaultTotalItems: number;
    defaultSubTotalExcludingSurcharges: string;
    defaultAmountUntilFreeDelivery: string;
    defaultHasWarnings: boolean;
    checkoutDisabled: boolean;
}

export default BasketSummary;
